module.exports = __webpack_public_path__ + "static/img/icon_about.b97d928.png";


//////////////////
// WEBPACK FOOTER
// ./src/image/index/icon_about.png
// module id = fG02
// module chunks = 11